// src/context/NavigationContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const NavigationContext = createContext();

export const useNavigation = () => useContext(NavigationContext);

export const NavigationProvider = ({ children }) => {
  const location = useLocation();

  // ⬇️ Ambil dari path aktif, bukan dari localStorage
  const [current, setCurrent] = useState(location.pathname);

  // 🔁 Sinkronkan current setiap URL berubah (misalnya user reload / buka langsung URL)
  useEffect(() => {
    setCurrent(location.pathname);
    if (process.env.NODE_ENV === 'development') {
      console.log('[NavigationContext] 🔁 Updated current menu from location:', location.pathname);
    }
  }, [location.pathname]);

  // 💾 Optional: Simpan untuk debugging atau restore jika perlu
  useEffect(() => {
    localStorage.setItem('currentMenu', current);
    if (process.env.NODE_ENV === 'development') {
      console.log('[NavigationContext] 💾 Saved current menu to localStorage:', current);
    }
  }, [current]);

  return (
    <NavigationContext.Provider value={{ current, setCurrent }}>
      {children}
    </NavigationContext.Provider>
  );
};
